import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import {
  ApiResponse,
  ApiErrorResponse,
  IStaffAuthTokenRequest,
} from "../utils/types";

const useGetAuthStaffUserV2 = (): UseQueryResult<
  ApiResponse<IStaffAuthTokenRequest>,
  ApiErrorResponse
> => {
  return useQuery({
    queryKey: ["auth-user"],
    queryFn: async () => {
      const response = await AXIOS_RESERVATION.get<
        ApiResponse<IStaffAuthTokenRequest>
      >(`v1/staff/auth`);

      return response.data;
    },
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};

export default useGetAuthStaffUserV2;
